import { motion } from "framer-motion";
import { UserCheck, FolderCheck, MessagesSquare, BadgeCheck, Route, HeartHandshake } from "lucide-react";
import { WHY_CHOOSE } from "../data/content";
import { SectionHeading, stagger, fadeUp } from "../lib/motion";
import { t } from "../i18n";

const ICONS = { UserCheck, FolderCheck, MessagesSquare, BadgeCheck, Route, HeartHandshake };

const WhyChoose = () => (
  <section id="why-choose" data-testid="why-choose-section" className="relative py-24 lg:py-32 bg-[#F7F6F2]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        light
        eyebrow={t("why.eyebrow")}
        title={t("why.title")}
        description={t("why.desc")}
        testid="why-choose-heading"
      />
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {WHY_CHOOSE.map((f, i) => {
          const Icon = ICONS[f.icon];
          return (
            <motion.div
              key={f.title}
              variants={fadeUp}
              data-testid={`why-card-${i}`}
              className="group bg-white rounded-2xl p-8 border border-slate-200/80 transition-all duration-400 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-20px_rgba(11,19,43,0.25)] hover:border-gold/60"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-navy text-gold mb-6 transition-transform duration-500 group-hover:scale-110">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="font-display text-lg font-bold text-navy mb-2.5 tracking-tight">{t(`why.items.${i}.title`, f.title.toUpperCase())}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{t(`why.items.${i}.text`, f.text)}</p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);

export default WhyChoose;
